module.exports = __webpack_public_path__ + "img/bag_2.483952d7.webp";